/**
 * Generates a random alphanumeric key of fixed length.
 *
 * @function
 * @returns {string} An 8-character random alphanumeric string.
 */
export const generateRandomKey = () => {
  return Math.random().toString(36).substring(0, 8);
};

/**
 * Generates a random numeric key with an optional prefix.
 *
 * @function
 * @param {number} [digits=7] - Number of digits for the random numeric part of the key.
 * @param {string} [prefix="ns=37457;i="] - The prefix to prepend to the random numeric key.
 * @returns {string} A string combining the prefix and a random numeric key of specified digits.
 */
export const generateRandomNsKey = (digits = 7, prefix = "ns=37457;i=") => {
  const min = Math.pow(10, digits - 1);
  const max = Math.pow(10, digits) - 1;
  const number = Math.floor(min + Math.random() * (max - min + 1));

  return `${prefix}${number}`;
};
